import axios from 'axios'
import { ApiConfig } from '../../config/api'
import { Filter } from '../../components/_WMS/FilterComponent'
import { ICreatePosition, IEditPosition } from '../../interfaces/Position/Position'

export const getPositionList = (
  filters?: Filter[],
  page = 0,
  pageSize = 5,
  orderBy?: { field: string; direction: 'asc' | 'desc' }
) => {
  const url = new URL(`${ApiConfig.PositionApi}`)
  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      url.searchParams.append(element.key, element.value.toString())
    })
  }

  if (orderBy?.field) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  return axios.get(url.toString())
}

export const getPositionDetail = (positionId: number) =>
  axios.get(`${ApiConfig.PositionApi}/${positionId}`)

export const deletePosition = (id: number) =>
  axios.delete(`${ApiConfig.PositionApi}/${id}`)

export const createPosition = (payload: ICreatePosition) =>
  axios.post(`${ApiConfig.PositionApi}`, payload)

export const updatePosition = (payload: IEditPosition) =>
  axios.put(`${ApiConfig.PositionApi}/${payload.positionId}`, payload)

export const getTypePositionsDDL = () =>
  axios.get(`${ApiConfig.TypepositionApi}?pageSize=500`)

export const exportPositionsMassive = (filters: { key: string; value: any }[]) => {
  const url = new URL(`${ApiConfig.ProcessApi}/PositionMassiveExport`)
  filters.forEach(({ key, value }) => url.searchParams.append(key, value.toString()))
  return axios.get(url.toString())
}

export const getPositionTemplate = (nameFileTemplate: string) =>
  axios.get(`${ApiConfig.ProcessApi}/GetTemplateFile/${nameFileTemplate}`)
